import ContractEquipmentPagination from "./ContractEquipmentPagination";

export default ContractEquipmentPagination;
